import { Branch } from '../models';

export const prepareBranchList = (
  branches: Branch[],
  search: string,
  mainBranchName: string
): Branch[] => {
  return (
    branches
      .map(b => new Branch(b))
      // sort branches starting with searched name
      .sort(b => (b?.name?.startsWith(search) ? -1 : 0))
      // remove main branch if exist (as it's already in the list)
      .filter(b => b.name !== mainBranchName)
  );
};
